export interface RequestPOIInfoItem {
    PersonId: number;
    CaInternalAssessmentNo?: string;
    DateOfAssessment?: string;
    PersonType: string;
    FirstName: string;
    LastName: string;
    LegalName: string;
    AlsoKnownAs: string;
    LeiRegistration: string;
    CountryInc: string;
    CityOfBirth: string;
    CountryOfBirth: string;
    DateOfBirth: string;
    SocialSecurityNumber: string;
    ID: string;
}

export function initRequestPOIInfoItem(): RequestPOIInfoItem {
    return {
        PersonId : 0,
        CaInternalAssessmentNo: '',
        DateOfAssessment: '',
        PersonType: '',
        FirstName: '',
        LastName: '',
        LegalName: '',
        AlsoKnownAs: '',
        LeiRegistration: '',
        CountryInc: '',
        CityOfBirth: '',
        CountryOfBirth: '',
        DateOfBirth: '',
        SocialSecurityNumber: '',
        ID: '',
    };
}